






















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject, Watch } from "vue-property-decorator";
import { ModelState } from "@elite/validation";
import { RestClient } from "@elite/restclient";
import { IPromotionUpsellModel } from "../../models";
import PromotionManagementEvents from "./PromotionManagementEvents";

@Component
export default class PromotionUpsellModal extends Vue {
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ required: false, type: Number, default: null })
    promotionId!: number | null;

    @Prop({ required: false, type: Number, default: 0 })
    id!: number;

    @Prop({ required: true, type: Boolean })
    value!: boolean;

    model: IPromotionUpsellModel | null = null;

    get localValue(): boolean {
        return this.value;
    }
    set localValue(value: boolean) {
        this.$emit("input", value);
    }

    async saveClicked(): Promise<void> {
        if (!this.model) {
            return;
        }

        const response = await this.restClient.postJson(
            "/api/PromotionUpsell",
            this.model
        );

        if (this.modelState.hasErrors(response)) {
            this.modelState.addResponseErrors(response, this);
            return;
        }

        this.$root.$emit(
            PromotionManagementEvents.promotionUpsellGridRefreshEvent
        );
        this.localValue = false;
    }

    @Watch("value")
    @Watch("id")
    async resetModel(): Promise<void> {
        if (this.id === 0) {
            if (!this.promotionId) {
                return;
            }

            this.model = {
                id: 0,
                name: null,
                price: 0,
                shippingPrice: 0,
                upsellHeaderText: null,
                upsellDescription: null,
                upsellImage: null,
                promotionId: this.promotionId,
                promotionButtonColor: null,
                sortOrder: null,
                choiceCode: null
            };
        } else {
            const response = await this.restClient.getJson<
                IPromotionUpsellModel
            >(`/api/PromotionUpsell/${this.id}`);

            if (response.status !== 200 || !response.data) {
                this.localValue = false;
            } else {
                this.model = response.data;
            }
        }
    }
}
